export default function imageHolder() {
  return {
    content: {}
  }
}
